import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useNetworkStatus from '@/hooks/useNetworkStatus';

interface NetworkAwareRouterProps {
  children: React.ReactNode;
}

const NetworkAwareRouter: React.FC<NetworkAwareRouterProps> = ({
  children,
}) => {
  const { isOnline } = useNetworkStatus();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If we're offline and not already on the offline page, redirect
    if (!isOnline && location.pathname !== '/offline') {
      // Only redirect if we're not on a critical page that should work offline
      const criticalOfflinePages = ['/', '/stats', '/settings'];
      if (!criticalOfflinePages.includes(location.pathname)) {
        navigate('/offline');
      }
    }
  }, [isOnline, location.pathname, navigate]);

  // If offline and on a non-critical page, show offline page
  if (
    !isOnline &&
    location.pathname !== '/offline' &&
    !['/', '/stats', '/settings'].includes(location.pathname)
  ) {
    return null; // Let the router handle the redirect
  }

  return <>{children}</>;
};

export default NetworkAwareRouter;
